<template>
  <main class="main">
    <!--我的帳戶開始-->
    <h1>裝置管理</h1><!--目前所在頁面標題-->
    <section class="device_list">
      <ul>
        <li  v-for = "devicesData in devicesDatas" :key="devicesData.id">
          <h2>{{devicesData.name}}</h2>
          <b>型號：{{devicesData.model}}</b>
          <i>上次使用時間：{{convertUTCTimeToLocalTime(devicesData.updated_at)}}</i>
          <div class="status">
            <button type="button" @click="deleteDevice(devicesData.id)" >刪除</button>
          </div>
        </li>
      </ul>
      <div class="toast">
        <div class="wrap">已刪除裝置</div>
      </div>
    </section>

    <section class="emptyPage" v-if="devicesDatas.length == 0">
      <div class="wrap">
        <figure>
          <img src="@/assets/images/status_empty_device.png">
          <figcaption>
            您目前沒有用任何行動裝置登入一刻鯨選 App
          </figcaption>
        </figure>
      </div>
    </section>
    <!--我的帳戶結束-->
  </main>

</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from 'vuex'

export default {
  name: 'async',
  metaInfo () {
    return {

      title: '裝置管理 | 我的 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '裝置管理 | 我的 | 一刻鯨選' },
        { property: 'og:site_name', content: '裝置管理 | 我的 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '登入後，即可查看帳戶所有資訊。' }

      ]
    }
  },
  data () {
    return {
      devicesDatas: []
    }
  },
  computed: {
    ...mapGetters(['userInfo,credentialToken'])

  },
  created () {
    this.axios
      .get(this.$store.getters.baseURL + 'devices', { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } })
      .then(response => {
        this.devicesDatas = response.data
      })
      .catch(error => console.log('log:' + error))
  },
  methods: {
    convertUTCTimeToLocalTime: function (UTCDateString) {
      if (!UTCDateString) {
        return '-'
      }
      function formatFunc (str) { // 格式化显示
        return str > 9 ? str : '0' + str
      }
      var date2 = new Date(UTCDateString) // 这步是关键
      var year = date2.getFullYear()
      var mon = formatFunc(date2.getMonth() + 1)
      var day = formatFunc(date2.getDate())
      var hour = date2.getHours()
      //   var noon = hour >= 12 ? 'PM' : 'AM';
      // hour = hour>=12?hour-12:hour;
      // hour = formatFunc(hour);
      var min = formatFunc(date2.getMinutes())
      var dateStr = year + '-' + mon + '-' + day + ' ' + hour + ':' + min
      return dateStr
    },
    deleteDevice (id) {
      this.axios
        .delete(this.$store.getters.baseURL + 'devices/' + id,
          { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } })
        .then(response => {
          // this.devicesDatas = response.data
          // location. reload()
          $('.toast').slideDown()
          window.setTimeout(function () {
            $('.toast').slideUp()
            location.reload()
          }, 1000)
        })
        .catch(error => console.log('log:' + error))
    }
  }
}
</script>

<style>

@import '../../../assets/css/user.css';
@import '../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyDevice.vue